const DailyLifeCardsData = [
  {
    id: 0,
    iconMobilePath: "mobile/daily-life/log.png",
    iconDesktopPath: "desktop/daily-life/log.png",
    title: "1. ACCESS",
    article:
      "Gain access to your EMR, portals and other electronic resources with a secure login.",
    articleExt: (
      <>
        To efficiently provide expedient access to medication, secure access is
        needed and will be provided. Information retrieved and utilized may
        include:
        <ul style={{ margin: "1rem", padding: "0 0 0 1rem" }}>
          <li style={{ padding: "0 0 .5rem 0" }}>
            Medical records needed for prior authorizations and letters of
            appeal on your patient’s behalf.
          </li>
          <li style={{ padding: "0 0 .5rem 0" }}>
            Send prescription’s and written orders to pharmacies, labs etc. in
            compliance with the provider’s standards and follow ups.
          </li>
          <li style={{ padding: "0 0 .5rem 0" }}>
            Submit information for creation of copay assistance via Vendor
            portals.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: 1,
    iconMobilePath: "mobile/daily-life/advocate.png",
    iconDesktopPath: "desktop/daily-life/advocate.png",
    title: "2. ADVOCATE",
    article: "We fight for access to therapies on your patient’s behalf.",
    articleExt: (
      <>
        Information retrieved and utilized may include:
        <ul style={{ margin: "1rem", padding: "0 0 0 1rem" }}>
          <li style={{ padding: "0 0 .5rem 0" }}>
            Present arguments to the insurance companies via letters of appeal,
            as to legitimate rationale why patients need access to therapy.
          </li>
          <li style={{ padding: "0 0 .5rem 0" }}>
            Assist in peer to peer scheduling if needed.
          </li>
          <li style={{ padding: "0 0 .5rem 0" }}>
            Sign patients up for copay cards to help decrease out of pocket
            cost.
          </li>
          <li style={{ padding: "0 0 .5rem 0" }}>
            Interact with manufacturer bridge programs and provide necessary
            information needed to provide expedient access to therapy, while
            waiting for insurance authorizations or appealing denials.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: 2,
    iconMobilePath: "mobile/daily-life/contact.png",
    iconDesktopPath: "desktop/daily-life/contact.png",
    title: "3. COMMUNICATE",
    article:
      "Liaison between the provider’s office, pharmacy, patient and vendor, staying informed every step of the way.",
    articleExt: (
      <>
        <p>
          Having a one stop trusted source that provides necessary communication
          to all parties, will cut down on the number of confused patients,
          repeat phone calls and duplicate faxes, coming to your office.
          <hr style={{ border: "none", margin: ".5rem 0 0 0" }} />
          Call patients and provide over the phone medication counseling and
          answer questions needed to reassure access to therapy.
          <hr style={{ border: "none", margin: ".5rem 0 0 0" }} />
          Communicate with manufacturer bridge programs and provide necessary
          information needed to provide expedient access to therapy, while
          waiting for insurance authorizations or appealing denials.
        </p>
      </>
    ),
  },
  {
    id: 3,
    iconMobilePath: "mobile/daily-life/confirm.png",
    iconDesktopPath: "desktop/daily-life/confirm.png",
    title: "4. PREPARE",
    article:
      "Correspond with mandated pharmacies, after the medication has been approved, we will:",
    articleExt: (
      <>
        <ul style={{ margin: "1rem", padding: "0 0 0 1rem" }}>
          <li style={{ padding: "0 0 .5rem 0" }}>
            Correspond with mandated pharmacies, after the medication has been
            approved.
          </li>
          <li style={{ padding: "0 0 .5rem 0" }}>
            Confirm delivery of in-office administered medications.
          </li>
        </ul>
      </>
    ),
  },
];

export default DailyLifeCardsData;
